import { render, staticRenderFns } from "./DisplayCollection.vue?vue&type=template&id=6dbbf6f3&scoped=true&"
import script from "./DisplayCollection.vue?vue&type=script&lang=js&"
export * from "./DisplayCollection.vue?vue&type=script&lang=js&"
import style0 from "./DisplayCollection.vue?vue&type=style&index=0&id=6dbbf6f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbbf6f3",
  null
  
)

export default component.exports